import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput2, SearchSubmitButton } from "../Form/Form";
import { addOneToDate } from "../../util/fn";
import { ArrowDown, ArrowUp } from "../../util/Svg";

const OBJ_TABLE = {
  "registered on": "createdAt",
  "organization name":"organizationName",
  "last name": "lastName",
  "first name": "firstName",
  sport: "sportName",
  // email: "email",
  // "phone number": "fullContact",
  country: "countryName",
  "total athletes":"athletes",
  "total coaches":"coaches",
  "total club managers":"clubManagers",
  status: "approvalStatus",
  "last payment on": "lastTransactionDate", 
};


const searchQueryHandler = (
  page,
  per_page,
  sortBy,
  order,
  approvalStatus = "",
  firstName = "",
  lastName = "",
  email = "",
  country = "",
  sport = "",
  dateFrom = "1970-01-01",
  dateTo
) => {
  if (sortBy.length > 0) {
    if (sortBy == "registered on") {
      sortBy = "createdAt";
    } else if (sortBy == "first name") {
      sortBy = "firstName";
    } else if (sortBy == "last name") {
      sortBy = "lastName";
    } else if (sortBy == "organization name") {
      sortBy = "organizationName";
    } else if (sortBy == "phone number") {
      sortBy = "contact";
    }else if (sortBy == "country") {
      sortBy = "countryName";
    }else if (sortBy == "sport") {
      sortBy = "sportName";
    }else if (sortBy == "total athletes") {
      sortBy = "athletes";
    }else if (sortBy == "total coaches") {
      sortBy = "coaches";
    }else if (sortBy == "total club managers") {
      sortBy = "clubManagers";
    }else if (sortBy == "last payment on") {
      sortBy = "lastTransactionDate";
    }
  } else {
    sortBy = "createdAt";
  }
  order = order.length > 0 ? order : "desc";

  dateFrom = dateFrom.length > 0 ? dateFrom : "1970-01-01";

  dateTo = dateTo ? addOneToDate(new Date(dateTo)) : addOneToDate(new Date());

  return `club/all?page=${page}&per_page=${per_page}&sortBy=${sortBy}&order=${order}&approvalStatus=${approvalStatus}&firstName=${firstName}&lastName=${lastName}&email=${email}&country=${country}&sport=${sport}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
};

const ViewAll = () => {
  const [seekers, setSeekers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(10);
  const [perPage, setPerPage] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "registered on",
    order: "desc",
  });

  const MySwal = withReactContent(Swal);

  const { records_per_page } = useSelector((state) => state.setting);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
    setError,
    setValue,
    control
  } = useForm();

  const { request, response } = useRequest();
  const { request: requestChangeStatus, response: responseChangeStatus } =
    useRequest();
  const { request: requestDelete, response: responseDelete } = useRequest();
  const { request: requestSendCreds, response: responseSendCreds } =
    useRequest();
  const { request: requestSport, response: responseSport } = useRequest();
  const { request: requestCountry, response: responseCountry } = useRequest();
  const [allSports, setAllSports] = useState([]);
  const [allCountry, setAllCountry] = useState([]);

  const [searchObj, setSearchObj] = useState({
    firstName: "",
    lastName: "",
    email: "",
    sports: "",
    country: "",
    dateFrom: "",
    dateTo: ""
  });
  const [isDisableSearch, setIsDisableSearch] = useState(true)
  const [isSearchToggleOpen, setIsSearchToggleOpen] = useState(false);

  const handleToggle = () => {
    const collapseElement = document.getElementById('collapseOne6');
    if (collapseElement) {
      collapseElement.classList.toggle('show');
    }
    setIsSearchToggleOpen(!isSearchToggleOpen);
  };

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      request(
        "GET",
        searchQueryHandler(
          1,
          records_per_page,
          currentSort.sortBy,
          currentSort.order
        )
      );
    }
    requestSport("GET", `master/all?page=1&isActive=${true}`)
    requestCountry("GET", `country/all?page=1&isActive=${true}`)
    document.title = "Clubs - Calevalab";
  }, [records_per_page]);

  useEffect(() => {
    if (response) {
      setSeekers(response.data);
      setTotalDocuments((prev) =>
        response.totalDocuments !== undefined && response.totalDocuments !== null ? response.totalDocuments : prev
      );
    }
  }, [response]);
  useEffect(() => {
    if (responseSport && responseSport.status) {
      setAllSports(responseSport.sports)
    }
  }, [responseSport])

  useEffect(() => {
    if (responseCountry && responseCountry.status) {
      setAllCountry(responseCountry.data)
    }
  }, [responseCountry])

  useEffect(() => {
    if (responseChangeStatus) {
      const { id, status } = responseChangeStatus;

      const oldSeekers = [...seekers];
      const indexToChange = oldSeekers.findIndex((seeker) => seeker._id == id);
      oldSeekers[indexToChange].approvalStatus = status;
      setSeekers(oldSeekers);
      toast.success("Club's status has been changed successfully.")
    }
  }, [responseChangeStatus]);

  useEffect(() => {
    if (responseDelete) {
      const { id } = responseDelete;
      let newSeeker = [...seekers];
      newSeeker = newSeeker.filter((seeker) => seeker._id != id);
      setSeekers(newSeeker);
      toast.success("Club has been deleted successfully.");
    }
  }, [responseDelete]);

  useEffect(() => {
    if (responseSendCreds) {
      toast.success("Login credentials sent successfully");
    }
  }, [responseSendCreds]);

  const fetchMoreData = ({ selected }) => {
    setSeekers([]);
    const { approvalStatus, firstName, lastName, email, dateFrom, dateTo, country, sportName } =
      getValues();

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        approvalStatus,
        firstName,
        lastName,
        email,
        country, sportName,
        dateFrom,
        dateTo
      )
    );
  };

  const deleteHandler = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to delete this club?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "No, cancel",
      reverseButtons: true, allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        requestDelete("DELETE", "club", { id });
      } else if (result.isDismissed) {
      }
    });
  };

  const onSearchHandler = () => {
    const { approvalStatus, firstName, lastName, email, dateFrom, dateTo, country, sportName } =
      getValues();
    let error = 0;
    if (dateFrom && dateTo) {
      if (Moment(dateFrom).isAfter(dateTo) && !Moment(dateFrom).isSame(dateTo, 'day')) {
        setError("dateTo", {
          type: "manual_other",
          message: "To Date cannot be smaller than From Date",
        });
        error = 1;
      }
    }
    if (new Date(dateTo).getTime() > new Date().getTime()) {
      setError("dateTo", { type: "manual", message: "manual" })
      error = 1;
    }
    if (new Date(dateFrom).getTime() > new Date().getTime()) {
      setError("dateFrom", { type: "manual" })
      error = 1;
    }
    if (error == 1) {
      return;
    }
    request(
      "GET",
      searchQueryHandler(
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        approvalStatus,
        firstName,
        lastName,
        email,
        country, sportName,
        dateFrom,
        dateTo
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("approvalStatus");
    resetField("firstName");
    resetField("lastName");
    resetField("email");
    resetField("country");
    // resetField("sportName");
    resetField("dateFrom");
    resetField("dateTo");
    setValue("sportName", "");
    setValue("country", "");

    setIsDisableSearch(true);

    request(
      "GET",
      searchQueryHandler(1, perPage, currentSort.sortBy, currentSort.order)
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    const { approvalStatus, firstName, lastName, email, dateFrom, dateTo, country, sportName } =
      getValues();

    request(
      "GET",
      searchQueryHandler(
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        approvalStatus,
        firstName,
        lastName,
        email,
        country, sportName,
        dateFrom,
        dateTo
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const sortingHandler = (sortBy) => {
    const { approvalStatus, firstName, lastName, email, dateFrom, dateTo, country, sportName } =
      getValues();

    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          newOrder,
          approvalStatus,
          firstName,
          lastName,
          email,
          country, sportName,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          "desc",
          approvalStatus,
          firstName,
          lastName,
          email,
          country, sportName,
          dateFrom,
          dateTo
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const changeStatusHandler = (id, approvalStatus, organizationCode) => {
    const status = approvalStatus == 'Approved' ? 'Rejected' : 'Approved';

    MySwal.fire({
      title: "Are you sure?",
      text: "Want to change this status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        requestChangeStatus("PUT", "club/status", {
          id,
          status,
          organizationCode
        });
      } else if (result.isDismissed) {
      }
    });
  };

  const sendCredentials = (id) => {
    requestSendCreds("POST", "club/send-credentials", { id });
  };

  const InputFields = [
    {
      label: "First Name",
      name: "firstName",
      required: false,
    },
    {
      label: "Last Name",
      name: "lastName",
      required: false,
    },
    {
      label: "Email",
      name: "email",
      required: false,
    },
    {
      isSelectInput: true,
      label: "Sports",
      name: "sportName",
      required: false,
      children: allSports && allSports.length > 0 && (
        [
          { value: "", label: "Select Sport" }, 
          ...(allSports && allSports.length > 0
            ? allSports.map(obj => ({ value: obj._id, label: obj.name }))
            : []
          )
        ]
      ),
      control: control
    },
    {
      isSelectInput: true,
      label: "Country",
      name: "country",
      required: false,
      children: allCountry && allCountry.length > 0 && (
        [
          { value: "", label: "Select Country" },
          ...(allCountry && allCountry.length > 0
            ? allCountry.map(obj => ({ value: obj._id, label: obj.name }))
            : []
          )
        ]
      ),
      control: control
    },

    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "From Date cannot be greater than Current Date",
      },
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "To Date cannot be greater than Current Date",
      },
    }
  ];

  const handleSearchObj = (name, value) => {
    if (name == 'dateTo') {
      if (new Date(value).getTime() > new Date().getTime()) {
        setError("dateTo", { type: "manual", message: "manual" })
        return;
      }
      clearErrors(name);
    }
    if (name == 'dateFrom') {
      if (new Date(value).getTime() > new Date().getTime()) {
        setError("dateFrom", { type: "manual", message: "manual" })
        return;
      }
      clearErrors(name);
    }
    let search = searchObj;
    search[name] = value;
    setSearchObj(search);
    if (search?.dateFrom && search?.dateTo) {
      if (Moment(search?.dateFrom).isAfter(search?.dateTo) && !Moment(search?.dateFrom).isSame(search?.dateTo, 'day')) {
        setError("dateTo", {
          type: "manual_other",
          message: "To Date cannot be smaller than From Date",
        });
        return;
      }
    }

    if (search?.firstName || search?.lastName || search?.email || search?.sportName || search?.country || search?.dateFrom || search?.dateTo) {
      setIsDisableSearch(false);
    } else {
      setIsDisableSearch(true);
    }
  }


  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb title="Clubs" links={[{ to: "/", name: "Dashboard" }]} />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      className="btn btn-primary dropdown-toggle mr-2"
                      onClick={handleToggle}
                    >
                      Search {isSearchToggleOpen ? <ArrowUp /> : <ArrowDown />}
                    </a>
                    <Link to="/club/add" className="btn btn-primary">
                      Add New Club
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse"
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput2
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                                setValue={setValue}
                                handleSearchObj={handleSearchObj}
                              />
                            ))}
                          </div>

                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                            isDisableSearch={isDisableSearch}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="dataTables_wrapper ">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={seekers}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      links={[
                        {
                          isLink: false,
                          name: "Rejected",
                          click: changeStatusHandler,
                          title: "Click To Approve",
                        },
                        {
                          isLink: false,
                          name: "Approved",
                          click: changeStatusHandler,
                          title: "Click To Reject",
                        },
                        {
                          isLink: true,
                          to: "/club/view",
                          name: "View",
                          extraData: true,
                        },
                        {
                          isLink: true,
                          to: "/club/edit",
                          name: "Edit",
                          extraData: true,
                        },
                        { isLink: false, name: "Delete", click: deleteHandler },
                        {
                          isLink: true,
                          to: "/club/change-password",
                          name: "ChangePassword",
                          extraData: true,
                          title: "Change Password",
                        },
                        {
                          isLink: false,
                          name: "SendCreds", 
                          click: sendCredentials,
                          title: "Send Credentials",
                        },
                      ]}
                      onlyDate={{
                        createdAt: "date",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                      renderAs={{
                        firstName: (data, id, showData) => {
                          return (
                            <Link to={`/club/view/${showData?._id}`} className="text-primary tableLink">
                              {data}
                            </Link>
                          );
                        },
                        lastName: (data, id, showData) => {
                          return (
                            <Link to={`/club/view/${showData?._id}`} className="text-primary tableLink">
                              {data}
                            </Link>
                          );
                        },
                        athletes: (data, id, showData) => {
                          return (
                            data ? (
                              <Link to={`/athletes?clubId=${showData?._id}`} className="tableLink">{data}</Link>
                            ):"0"
                          )
                        },
                        coaches: (data, id, showData) => {
                          return (
                            data ? (
                              <Link to={`/coaches?clubId=${showData?._id}`} className="tableLink"
                             >{data}</Link>
                            ):"0"
                          )
                        }
                      }}
                    /> 

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={seekers.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAll;
